import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConst } from '@app/App.const';
import { catchError, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiHttpService {
  constructor(private http: HttpClient) {}

  public callApi(
    method: string,
    url: string,
    data?: any,
    options?: any,
    requireFullResponse: boolean=false
  ): Observable<any> {
    switch (method) {
      case AppConst.HttpMethods.GET:
        return this.http
          .get(url, options)
          .pipe(map(this.resonseHandler), catchError(this.errorHandler(requireFullResponse)));
      case AppConst.HttpMethods.POST:
        return this.http
          .post(url, data, options)
          .pipe(map(this.resonseHandler), catchError(this.errorHandler(requireFullResponse)));
      case AppConst.HttpMethods.PUT:
        return this.http
          .put(url, data, options)
          .pipe(map(this.resonseHandler), catchError(this.errorHandler(requireFullResponse)));
      case AppConst.HttpMethods.DELETE:
        return this.http
          .delete(url, options)
          .pipe(map(this.resonseHandler), catchError(this.errorHandler(requireFullResponse)));
      default:
        return this.http
          .get(url, options)
          .pipe(map(this.resonseHandler), catchError(this.errorHandler(requireFullResponse)));
    }
  }

  private resonseHandler(res: any) {
    return res;
  }

  private errorHandler(requireFullResponse: boolean = false) {
    return (error: any) => {
      return new Observable((obs) => {
        if (requireFullResponse) {
          // changes so I can get the full response in the component and not just the error message
          // making changes to the error handler in this way because it is used in many places and I don't want to break anything
          obs.next(error);
        } else if (typeof error.error == 'string') {
          obs.next({ error: error.error });
        } else {
          obs.next(error.error);
        }
      });
    };
  }
}
